/* LIVE-MOTION — kurzor-követő réteg (2026-07-23)
   Csak azt csinálja, amit CSS nem tud: a kurzor pozícióját írja CSS-változóba.
   Minden más (haladásjelző, hover-feedback) natív CSS — nulla JS.

   REFINED: a fénykör LERP-pel (lineáris interpoláció) követi a kurzort, nem
   ugrik rá. Ez a különbség a "ragadós/olcsó" és a "sima/prémium" érzet között.
   A rAF-hurok csak akkor jár, ha van tényleges elmozdulás — üresjáratban leáll,
   így nem eszi a CPU-t.

   Csak egérrel (pointer:fine) és csak reduced-motion nélkül fut. Érintőn nem. */
(function () {
  var fine = window.matchMedia('(pointer: fine)').matches;
  var okMotion = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!fine || !okMotion) return;

  var root = document.documentElement;

  // cél (a valódi kurzor) és aktuális (a kirajzolt kör) pozíció
  var tx = window.innerWidth / 2, ty = window.innerHeight * 0.35;
  var cx = tx, cy = ty;
  var running = false;

  var EASE = 0.12;      // követés lágysága: kisebb = lomhább, nagyobb = ragadósabb
  var EPS  = 0.35;      // ennél kisebb elmozdulásnál leállítjuk a hurkot

  function frame() {
    var dx = tx - cx, dy = ty - cy;
    cx += dx * EASE;
    cy += dy * EASE;
    root.style.setProperty('--mx', cx.toFixed(1) + 'px');
    root.style.setProperty('--my', cy.toFixed(1) + 'px');

    if (Math.abs(dx) > EPS || Math.abs(dy) > EPS) {
      requestAnimationFrame(frame);
    } else {
      running = false;    // üresjárat: nem pörgetjük tovább a rAF-ot
    }
  }

  function kick() {
    if (!running) { running = true; requestAnimationFrame(frame); }
  }

  window.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;  // toll/érintés kizárva
    tx = e.clientX; ty = e.clientY;
    if (root.getAttribute('data-cursor') !== 'on') root.setAttribute('data-cursor', 'on');
    kick();
  }, { passive: true });

  /* ---- Rács-igazítás görgetéskor -------------------------------------------
     Az alap-rács a `html`-en ül és a dokumentummal EGYÜTT görög; ez a réteg
     `position:fixed`. Ha nem kompenzálunk, a két rács `scrollY % 40` mértékben
     elcsúszik (0px-nél fedésben, 20px-nél félrecsúszva). A --gy-t a scroll
     maradékára állítjuk, a CSS ezzel tolja vissza a hover-rács kezdőpontját. */
  var lastGy = -1;
  function syncGrid() {
    var gy = ((window.scrollY % 40) + 40) % 40;
    if (gy !== lastGy) { lastGy = gy; root.style.setProperty('--gy', gy + 'px'); }
  }
  syncGrid();
  window.addEventListener('scroll', function () {
    requestAnimationFrame(syncGrid);
  }, { passive: true });
  window.addEventListener('resize', syncGrid, { passive: true });

  /* ---- Use-case választó: hover + kattintás visszajelzés -------------------
     A kártyán belüli kurzorpozíciót írjuk CSS-változóba, hogy a fény a kurzort
     kövesse. Delegált listener — nem kötünk N külön eseményt. */
  var CARD_SEL = '.uchc__card';
  var activeCard = null;

  document.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var card = e.target.closest ? e.target.closest(CARD_SEL) : null;
    if (card !== activeCard && activeCard) resetCard(activeCard);
    activeCard = card;
    if (!card) return;
    var r = card.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var rx = (e.clientX - r.left) / r.width;
    var ry = (e.clientY - r.top) / r.height;
    card.style.setProperty('--px', (rx * 100).toFixed(1) + '%');
    card.style.setProperty('--py', (ry * 100).toFixed(1) + '%');
  }, { passive: true });

  function resetCard(c) {
    c.style.removeProperty('--px');
    c.style.removeProperty('--py');
  }

  // az egér elhagyta az ablakot → a kör elhalványul (a CSS opacity-vel)
  document.addEventListener('mouseleave', function () {
    root.setAttribute('data-cursor', 'off');
  }, { passive: true });
  document.addEventListener('mouseenter', function () {
    root.setAttribute('data-cursor', 'on');
  }, { passive: true });

})();
